/**
 *  @file       message-authentication.js
 *  @author     Ryan Rossiter, ryan@kingsds.network
 *              Ryan Saweczko, ryansaweczko@distributive.network
 *  @date       January 2020
 *              January 2024
 *
 *  Provide functions for authentication & validation of requests within the protocol.
 *  The *authorize functions need to be added to a message's prototype.
 */
'use strict';

const wallet = require('dcp/dcp-client/wallet');
const { assert } = require('dcp/common/dcp-assert');

if (true) // eslint-disable-line no-constant-condition
{
  if (true) // eslint-disable-line no-constant-condition
  {
    /**
     * This method authorizes `guardian` to use `resource` if `guardian`'s peer is `accessor`.
     *
     * @note: If the guardianAddress is not specified, the default is the peer address.
     *        If the connection is not established, this method will complete the connection,
     *        then complete the authorization.
     *
     * @param {wallet.Keystore} [resourceKeystore=wallet.get()]
     * @param {wallet.Address} [guardianAddress=this.connection.peerAddress]
     * @param {wallet.Address} [accessorAddress=this.connection.identity.address]
     */
    exports.authorize = async function authorize(resourceKeystore, guardianAddress, accessorAddress)
    {

      if (!(resourceKeystore instanceof wallet.Keystore || resourceKeystore instanceof wallet.PrivateKey))
        throw new Error('First argument to authorize must be instance of wallet.Keystore');

      assert(!guardianAddress || guardianAddress instanceof wallet.Address);
      assert(!accessorAddress || accessorAddress instanceof wallet.Address);

      // Memoize that default values (guardian is peerAddress, and accessor is identity.address) need to be used,
      // that may not be defined yet if our session isn't connected. Fill values in right before signing the message.
      if (!guardianAddress)
        guardianAddress = 'peerAddress';

      if (!accessorAddress)
        accessorAddress = 'identity.address';

      const resourceAddress = resourceKeystore.address;
      this.payload.allow.push({
        resource: resourceAddress.toString(),
        guardian: guardianAddress.toString(),
        accessor: accessorAddress.toString(),
      });

      if (!this.resourceKeystores.has(resourceAddress.toString()))
      {
        // Call unlock once so that we know it will be available to sign with
        await resourceKeystore.unlock();
        this.resourceKeystores.set(resourceAddress.toString(), resourceKeystore);
      }
    }

    /**
     * Method of Request
     *
     * This method is primarily used by the recipient of a message to verify
     * that it has been signed by the owner of the resource in question.
     *
     * @param {wallet.Address|string} resource
     * @param {wallet.Address|string} guardian - default is this.connection.identity.address
     * @param {wallet.Address|string} accessor - default is connection.peerAddress
     * @returns {boolean}
     *
     * Spec Errata: no validateSignature=false, no Address-cast
     */
    exports.doesAuthorize = function doesAuthorize(resource, guardian, accessor)
    {
      const self = this.connection.identity.address;
      const peer = this.connection.peerAddress;

      resource = wallet.Address(resource);
      guardian = guardian ? wallet.Address(guardian) : self;
      accessor = accessor ? wallet.Address(accessor) : peer;

      for (let allow of this.payload.allow)
      {
        if (true
            && resource.eq(allow.resource)
            && guardian.eq(allow.guardian)
            && accessor.eq(allow.accessor))
        {
          /* Our access principals match entry in the message payload's allow list */
          const resourceKey = String(resource);
          if (this.auth?.hasOwnProperty(resourceKey) && this.auth[resourceKey])
            return resource.verifySignature(this.payload, this.auth[resourceKey]);
        }
      }

      return false;
    }
  }
}
